import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../../store/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const { buscaToken } = React.useContext(AuthContext);
  const [erro, setErro] = React.useState(false);
  const navigate = useNavigate();

  async function validaServiceTicket() {
    const pegouToken = await buscaToken(searchParams.get('ticket'));

    if (pegouToken) {
      navigate('/',true);
    } else {
      setErro(true);
    }

  }

  React.useEffect(() => {
      validaServiceTicket();
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!erro && <div>Validando credenciais de acesso ...</div>}
      {erro && <div>Erro ao validar credenciais de acesso ...</div>}
    </>
  );
};

export default AuthCallback;